import styled from 'styled-components';
import Card from '../../common/card/Card';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const StyledDealSetupActivity = styled.div`
    width: 100%;
    flex: 1 1 0;
    background: ${({ theme }) => theme.tokens.ColorPrimary700 || '#0A468D'};
    padding: 32px 32px 100px 32px;

    @media (max-width: ${BreakPoints.TABLET}) {
        padding: 32px 20px 100px 20px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        padding: 32px 20px 100px 20px;
    }
`;

export const StyledDealSetupCard = styled.div`
    width: 100%;
    background: ${({ theme }) => theme.tokens.BaseColorGray50 || '#F4F4F4'};
    border-radius: 20px;
    padding: 20px;
`;

export const StyledDealSetupHeader = styled.div`
    margin-bottom: 20px;
`;

export const StyledDealSetupTitle = styled.h1`
    margin: 0 0 16px 0;
    font-size: 30px;
    font-weight: 700;
    color: ${({ theme }) => theme.tokens.BaseColorBlack || '#000000'};

    @media (max-width: ${BreakPoints.TABLET}) {
        font-size: 24px;
    }
`;

export const StyledDealSetupDescription = styled.p`
    margin: 0;
    font-size: ${({ theme }) => theme.tokens.SemTypographyHeadingH3?.fontSize || '20px'};
    font-weight: 400;

    @media (max-width: ${BreakPoints.PHONE}) {
        font-size: ${({ theme }) => theme.tokens.SemTypographyAnchorInlineMd?.fontSize || '16px'};
    }
`;
export const StyledAccordionContainer = styled.div`
    width: 100%;
    margin-bottom: 20px;

    & > [data-testid^='accordion-'] {
        background: ${({ theme }) => theme.tokens.BaseColorWhite};
        border: ${({ theme }) => `1px solid ${theme.tokens.BaseColorGray300}`};
        border-radius: ${({ theme }) => theme.tokens.BaseSizeBorderRadiusMd || '6px'};
    }

    & > [data-testid^='accordion-'] > [class*='accordion-head-'] {
        padding: 14px 16px 14px 18px;
        box-shadow: none;
    }

    & > [data-testid^='accordion-'] > [class*='accordion-head-'] > div:first-child {
        flex: 1;
    }

    /* Replace the default chevron icon with a plus (collapsed) / minus (expanded) indicator */
    & > [data-testid^='accordion-'] > [class*='accordion-head-'] [data-testid='chevron-down-icon'] {
        display: none;
    }

    & > [data-testid^='accordion-'] > [class*='accordion-head-'] button {
        position: relative;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
    }

    & > [data-testid^='accordion-'] > [class*='accordion-head-'] button::after {
        content: '+';
        font-size: 24px;
        font-weight: 400;
        line-height: 1;
        color: ${({ theme }) => theme.tokens.BaseColorBlue500 || '#0d65bf'};
    }

    & > [data-testid^='accordion-'] > .accordion-head-expanded button::after {
        content: '−';
    }

    & > [data-testid^='accordion-'] > [aria-expanded] {
        background-color: transparent;
    }

    & > [data-testid^='accordion-'] > [aria-expanded='true'] .accordion-content-inner {
        padding: 0 24px 16px;
    }

    & > [data-testid='accordion-deal-setup-customer-info-accordion'] .input-container {
        padding-bottom: 8px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        margin-bottom: 16px;

        & > [data-testid^='accordion-'] > [class*='accordion-head-'] {
            padding: 12px 12px 12px 16px;
        }
    }
`;

export const StyledAccordionTitle = styled.span`
    display: block;
    width: 100%;
    font-size: ${({ theme }) => theme.tokens.SemTypographyHeadingH4?.fontSize || '18px'};
    font-weight: 700;
    color: #16171a;
    cursor: pointer;

    @media (max-width: ${BreakPoints.PHONE}) {
        font-size: ${({ theme }) => theme.tokens.SemTypographyAnchorInlineMd?.fontSize || '16px'};
    }
`;

// Collapsed-state summary shown under the accordion title (e.g. selected
// customer name or selected vehicle name).
export const StyledAccordionSubtitle = styled.span`
    display: block;
    width: 100%;
    margin-top: 4px;
    font-size: ${({ theme }) => theme.tokens.SemTypographyListSm?.fontSize || '0.875rem'};
    font-weight: 400;
    color: #53565a;
`;

export const StyledDealSetupFooter = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${({ theme }) => theme.tokens.BaseColorWhite};
    border-top: 1px solid ${({ theme }) => theme.tokens.BaseColorGray300};
    padding: 16px 24px;
    display: flex;
    justify-content: flex-end; /* Align button to the right */
    align-items: center;
    z-index: 1000;

    button {
        min-width: 150px;
    }
`;

// DealSetupDealershipSection styles
export const StyledDealershipCard = styled(Card)`
    padding: 0;
    margin-bottom: 20px;
    background: transparent !important;
    display: block;
    border: 0;
    border-radius: ${({ theme }) => theme.tokens.BorderRadiusRadiusNone || '0'};
    box-shadow: none;
    #select-input-options-interstate-select-input {
        padding: 14px 18px 14px 18px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        margin-bottom: 16px;
        h2 {
            font-size: ${({ theme }) => theme.tokens.SemTypographyHeadingH3?.fontSize || '1.25rem'};
        }
        #select-input-options-interstate-select-input {
            padding: 12px 16px;
        }
    }
`;

export const StyledDealershipLabel = styled.span`
    font-size: ${({ theme }) => theme.tokens.SemTypographyListSm?.fontSize || '14px'};
    font-weight: 600;
    margin-bottom: 4px;
`;

export const StyledLoaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 8px;
    font-size: ${({ theme }) => theme.tokens.SemTypographyListSm?.fontSize || '0.875rem'};
    color: ${({ theme }) => theme.uiBricks?.nextStepsDescriptionColor || '#666666'};
`;

// DealSetupVehicleSection styles
export const StyledVehicleWrapper = styled.div`
    .change-vehicle-title {
        display: none !important;
    }
    .change-vehicle-footer {
        display: none !important;
    }
`;
